export interface BootScreenOptions {
  readonly maximumDurationMs?: number;
  readonly fadeDurationMs?: number;
}

export class BootScreen {
  private readonly root: HTMLElement;
  private readonly video: HTMLVideoElement;
  private readonly maximumDurationMs: number;
  private readonly fadeDurationMs: number;

  constructor(options: BootScreenOptions = {}) {
    const root = document.querySelector<HTMLElement>('#boot');
    const video = document.querySelector<HTMLVideoElement>('#boot-video');
    if (!root || !video) throw new Error('Boot screen markup is missing.');
    this.root = root;
    this.video = video;
    this.maximumDurationMs = options.maximumDurationMs ?? 9000;
    this.fadeDurationMs = options.fadeDurationMs ?? 650;
  }

  async play(): Promise<void> {
    this.root.classList.remove('complete');
    this.video.muted = true;
    this.video.currentTime = 0;

    await new Promise<void>(resolve => {
      let settled = false;
      const finish = (): void => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        this.video.removeEventListener('ended', finish);
        this.video.removeEventListener('error', finish);
        resolve();
      };
      const timeout = window.setTimeout(finish, this.maximumDurationMs);
      this.video.addEventListener('playing', () => this.root.classList.add('video-playing'), { once: true });
      this.video.addEventListener('ended', finish, { once: true });
      this.video.addEventListener('error', finish, { once: true });
      this.video.play().catch(finish);
    });
  }

  async dismiss(): Promise<void> {
    this.root.classList.add('complete');
    await new Promise(resolve => window.setTimeout(resolve, this.fadeDurationMs));
    this.video.pause();
    this.root.remove();
  }
}
